export default "__VITE_ASSET__7a6f86c6__"